import {
  Building2,
  FileCheck2,
  Activity,
  LayoutDashboard,
  Package,
  Percent,
  Receipt,
  ScrollText,
  Server,
  Users,
} from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import {
  canAccessKyb,
  canAccessMerchants,
  canAccessAuditLogs,
  canAccessCargo,
  canAccessStaff,
  canAccessSystem,
  canAccessTransactions,
  canEditCargoCommission,
} from '../../utils/roles';

export type ConsoleSection =
  | 'dashboard'
  | 'merchants'
  | 'cargo'
  | 'cargoCommission'
  | 'system'
  | 'kyb'
  | 'transactions'
  | 'audit'
  | 'staff';

type NavItem = {
  id: ConsoleSection;
  label: string;
  icon: typeof LayoutDashboard;
};

const ALL_ITEMS: NavItem[] = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { id: 'merchants', label: 'Merchants', icon: Building2 },
  { id: 'cargo', label: 'Cargo partners', icon: Package },
  { id: 'cargoCommission', label: 'Only Crypto Commissions', icon: Percent },
  { id: 'system', label: 'System & Ops', icon: Server },
  { id: 'kyb', label: 'KYB Center', icon: FileCheck2 },
  { id: 'transactions', label: 'Transactions', icon: Receipt },
  { id: 'audit', label: 'Audit log', icon: ScrollText },
  { id: 'staff', label: 'Staff Management', icon: Users },
];

type SidebarProps = {
  active: ConsoleSection;
  onSelect: (section: ConsoleSection) => void;
};

export function Sidebar({ active, onSelect }: SidebarProps) {
  const { role } = useAuth();

  const items = ALL_ITEMS.filter((item) => {
    if (item.id === 'merchants') return canAccessMerchants(role);
    if (item.id === 'cargo') return canAccessCargo(role);
    if (item.id === 'cargoCommission') return canEditCargoCommission(role);
    if (item.id === 'system') return canAccessSystem(role);
    if (item.id === 'kyb') return canAccessKyb(role);
    if (item.id === 'transactions') return canAccessTransactions(role);
    if (item.id === 'audit') return canAccessAuditLogs(role);
    if (item.id === 'staff') return canAccessStaff(role);
    return true;
  });

  return (
    <aside className="dash-sidebar">
      <div className="sidebar-section">Navigation</div>
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <button
            key={item.id}
            type="button"
            className={`sidebar-item${active === item.id ? ' active' : ''}`}
            onClick={() => onSelect(item.id)}
          >
            <Icon size={16} aria-hidden />
            {item.label}
          </button>
        );
      })}
    </aside>
  );
}
